import { FileFormat } from '@surveycake/logic-engine';
import { Wording } from '@surveycake/wording/survey';
import { t } from 'app/shared/i18n';

export function mapFileFormats(
  wording: Wording,
  format?: FileFormat[]
): string {
  if (!(format instanceof Array) || format.length === 0) {
    return wording.subject.fileupload.types.none;
  }

  return format
    .map(f => wording.subject.fileupload.types[f])
    .join(wording.subject.fileupload.info.seperator);
}

export function mapFileFormatsForErrorMap(
  wording: Wording,
  format?: FileFormat[]
): string {
  if (!(format instanceof Array) || format.length === 0) {
    return wording.subject.fileupload.types.none;
  }

  const filetype = format
    .map(f => wording.subject.fileupload.types[f])
    .join(wording.subject.fileupload.info.seperator);

  return t(wording.subject.fileupload.error.filetype, { filetype });
}
